import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { whatsappUrl } from '../content/siteContent';

const { FiHome, FiGrid, FiMapPin, FiMessageCircle } = FiIcons;

const navigation = [
  {
    id: 'inicio',
    label: 'Inicio',
    icon: FiHome,
    href: '#inicio'
  },
  {
    id: 'servicios',
    label: 'Servicios',
    icon: FiGrid,
    href: '#servicios'
  },
  {
    id: 'cobertura',
    label: 'Cobertura',
    icon: FiMapPin,
    href: '#cobertura'
  }
];

function MobileBottomNav() {
  const [activeSection, setActiveSection] = useState('inicio');

  useEffect(() => {
    const sections = navigation
      .map((item) => document.getElementById(item.id))
      .filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (visible[0]) {
          setActiveSection(visible[0].target.id);
        }
      },
      {
        rootMargin: '-25% 0px -55%',
        threshold: [0.1, 0.3, 0.6]
      }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <nav className="mobile-bottom-nav" aria-label="Navegación móvil principal">
      {navigation.map((item) => (
        <a
          className={activeSection === item.id ? 'is-active' : ''}
          href={item.href}
          key={item.id}
          aria-current={activeSection === item.id ? 'page' : undefined}
        >
          <SafeIcon icon={item.icon} />
          <span>{item.label}</span>
        </a>
      ))}
      <a
        className="mobile-bottom-nav__contact"
        href={whatsappUrl()}
        target="_blank"
        rel="noreferrer"
        aria-label="Pedir un mandao por WhatsApp"
      >
        <SafeIcon icon={FiMessageCircle} />
        <span>Pedir</span>
      </a>
    </nav>
  );
}

export default MobileBottomNav;